import React from "react";
import { CircularProgress } from "@mui/material";

function DefaultLoader({ loading }) {
  return <>{loading && <CircularProgress className="loader" />}</>;
}

export default DefaultLoader;
